import { StreamState, StreamNode } from "./partStore";
import { DESTINATION_LIST_DATA_GRID } from "../constant/dummyData";

export interface ProjectedDestinations {
  kind: string | null;
  version: number | null;
  singleSelectedDestination: false;
  preText: string;
  postText: string;
  destinationList: any[];
}

function asText(value: unknown): string {
  return value === null || value === undefined ? "" : String(value);
}

function toNum(value: unknown): number {
  const n = typeof value === "number" ? value : parseInt(asText(value), 10);
  return Number.isFinite(n) ? n : 0;
}

function childrenOf(state: StreamState, node: StreamNode): StreamNode[] {
  const out: StreamNode[] = [];
  for (const id of node.childIds) {
    const child = state.byId[id];
    if (child) out.push(child);
  }
  return out;
}

function rootNode(state: StreamState, tag: string): StreamNode | undefined {
  for (const id of state.rootIds) {
    const node = state.byId[id];
    if (node && node.tag === tag) return node;
  }
  return undefined;
}

function buildDestinationCard(node: StreamNode): any {
  const attrs = node.attrs;
  const name = asText(attrs.name);
  const city = asText(attrs.city);
  const country = asText(attrs.country);
  const cc = asText(attrs.cc);
  return {
    ...DESTINATION_LIST_DATA_GRID,
    id: node.id,
    destination_name: name,
    destination_city: city || name,
    destination_country: country,
    city_name: city || name,
    city_country: country,
    city_country_code: cc,
    country_code: cc,
    country,
    checkedFlag: false,
    checkFlag: false,
    imageURL: "",
  };
}

export function projectDestinations(state: StreamState): ProjectedDestinations {
  const intro = rootNode(state, "zv:intro");
  const outro = rootNode(state, "zv:outro");
  const destNode = rootNode(state, "zv:destinations");
  const placeNodes = destNode
    ? childrenOf(state, destNode).filter((node) => node.tag === "zv:place")
    : [];
  placeNodes.sort((a, b) => toNum(a.attrs.n) - toNum(b.attrs.n));
  const destinationList = placeNodes.map((node) => buildDestinationCard(node));

  return {
    kind: state.kind,
    version: state.version,
    singleSelectedDestination: false,
    preText: intro?.text ?? "",
    postText: outro?.text ?? "",
    destinationList,
  };
}

export function destinationDedupeKey(item: any): string {
  const name = asText(item?.destination_name || item?.city_name || item?.destination_city)
    .trim()
    .toLowerCase();
  const country = asText(
    item?.destination_country || item?.country || item?.country_code || item?.city_country_code,
  )
    .trim()
    .toLowerCase();
  return `${name}|${country}`;
}

export function dedupeDestinations(list: any[]): any[] {
  const seen = new Set<string>();
  const out: any[] = [];
  for (const item of list) {
    const name = asText(item?.destination_name || item?.city_name || item?.destination_city).trim();
    if (!name) {
      out.push(item);
      continue;
    }
    const key = destinationDedupeKey(item);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
}
